import { render } from "./VerifyEmailSuccess.vue?vue&type=template&id=002392f0"
import script from "./VerifyEmailSuccess.vue?vue&type=script&lang=js"
export * from "./VerifyEmailSuccess.vue?vue&type=script&lang=js"

import exportComponent from "/Users/qinzilie/INFURA-UI/infura-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__